<div class="common-textarea" [ngClass]="view" [formGroup]="form">
  <div class="d-flex w-100">
    @if (!context.noLabel) {
      <label [for]="domId" class="label text-nowrap" [ngClass]="{ required: required }">
        {{ context.label | translate }}
        @if (required) {
          <span class="color-error">*</span>
        }
      </label>
    }
    @if (context.lineLimit) {
      <app-form-field-line-count
        class="ms-auto me-0"
        [fieldValue]="field?.value"
        [lineLimit]="context.lineLimit"
        [limitLabel]="context.limitLabel"
      ></app-form-field-line-count>
    }
  </div>
  <span class="margin-bottom-xs"> {{ context.description | translate }} </span>
  <textarea
    appCtrlKey
    (change)="onChange()"
    (input)="onChange()"
    [attr.aria-describedby]="errorDomId"
    [attr.aria-invalid]="context.validateOnSubmitOnly ? false : field?.errors && field?.touched"
    [attr.aria-required]="required"
    [formControlName]="context.field"
    [name]="context.field"
    [placeholder]="context.placeholder | translate"
    [rows]="context.rows || 8"
    class="form-element w-100"
    id="{{ domId }}"
    [attr.required]="context.required ? '' : null"
  ></textarea>
  <div [id]="errorDomId" class="error-container">
    <app-form-field-error
      [formValidationRequest$]="formValidationRequest$"
      [field]="field"
      [name]="context.field"
      [label]="context.label"
      [customMessage]="context.customMessage"
      [overrideErrors]="context.overrideErrors"
      [validateOnSubmitOnly]="context.validateOnSubmitOnly"
      [errorMessageId]="errorDomId + '-message'"
    ></app-form-field-error>
  </div>
</div>
